import {
  AlertTriangle,
  CheckCircle2,
  CircleUserRound,
  Eye,
  Heart,
  Home,
  Info,
  Lock,
  Mail,
  Phone,
  Search,
  Settings,
  SquarePen,
  Trash2,
} from "lucide-react";
import React from "react";

export const MUI_ICON_CATALOG: Array<{ name: string; Icon: React.ElementType }> = [
  { name: "Search", Icon: Search },
  { name: "Home", Icon: Home },
  { name: "Settings", Icon: Settings },
  { name: "AccountCircle", Icon: CircleUserRound },
  { name: "Email", Icon: Mail },
  { name: "Phone", Icon: Phone },
  { name: "Delete", Icon: Trash2 },
  { name: "Edit", Icon: SquarePen },
  { name: "CheckCircle", Icon: CheckCircle2 },
  { name: "Info", Icon: Info },
  { name: "Warning", Icon: AlertTriangle },
  { name: "Favorite", Icon: Heart },
  { name: "Visibility", Icon: Eye },
  { name: "Lock", Icon: Lock },
];

export const MuiIconographyGrid: React.FC = () => (
  <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
    {MUI_ICON_CATALOG.map(({ name, Icon }) => (
      <div
        key={name}
        className="flex flex-col items-center justify-center rounded-lg border border-dashed border-[#E2E8F0] bg-[#F7FAFC] px-3 py-4 text-center"
      >
        <Icon className="h-6 w-6 text-[#4A5568]" />
        <span className="mt-2 font-mono text-[11px] text-[#2D3748]">{name}</span>
      </div>
    ))}
  </div>
);
